import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Row,
} from "reactstrap";

// Appens URL-schema (app.json, "scheme"). Att öppna det startar eller för fram appen.
const APP_LINK = "com.aplby.learnware://";

// Hit skickas användaren efter lyckad lösenordsuppdatering när återställningen startades från
// appen. Sidan försöker öppna appen direkt. Knappen är reserv: mobilwebbläsare kan kräva ett
// tryck för att öppna en egen URL, och är appen inte installerad händer ingenting.
function PasswordResetAppRedirect() {
  useEffect(() => {
    window.location.replace(APP_LINK);
  }, []);

  return (
    <div className="app flex-row align-items-center">
      <Container>
        <Row className="justify-content-center">
          <Col md="8">
            <CardGroup>
              <Card
                body
                className="text-white bg-success py-5 d-md-down-none"
                style={{ width: "44%" }}
              >
                <img
                  style={{ width: "100%" }}
                  src={"img/LearnWareLoggo.png"}
                  className="img-avatar"
                  alt="LearnWARE logga in"
                />
              </Card>
              <Card>
                <CardHeader>
                  <CardTitle className="h3" style={{ marginBottom: "0.25rem" }}>
                    <FormattedMessage id="ContinueInApp" />
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <p>
                    <FormattedMessage id="YouCanNowSignInToAppWithNewPassword" />
                  </p>
                  <Button
                    color="success"
                    block
                    onClick={() => window.location.replace(APP_LINK)}
                  >
                    <FormattedMessage id="GoToApp" />
                  </Button>
                </CardBody>
              </Card>
            </CardGroup>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default PasswordResetAppRedirect;
